/* ===== Popups Management (GDPR, Rules, etc.) ===== */
import { $ } from '../utils/helpers.js?v=83.79';
import { escapeHtml, fmtDate } from '../utils/helpers.js?v=83.79';
import { showSnackbar } from '../utils/ui.js?v=83.79';
import { getCurrentSettings } from '../services/settings.js?v=83.79';
import { openLegalDoc, getDisplayDoc } from '../legal/legal-ui.js?v=83.79';

// Client GDPR popup
function buildGDPRText() {
  const s = getCurrentSettings() || {};
  const sjOrg = isSpressJoyOrganizer(s);
  const opName = sjOrg ? SPRESSJOY_ORG.name : escapeHtml(s.companyName || 'localul');
  const opCui = sjOrg ? `, CUI ${SPRESSJOY_ORG.cui}, ${SPRESSJOY_ORG.seat}` : (s.cui ? `, CUI ${escapeHtml(s.cui)}` : '');
  const opEmail = sjOrg ? SPRESSJOY_ORG.email : (s.operatorEmail ? escapeHtml(s.operatorEmail) : '');
  const contact = opEmail ? `<strong>${opEmail}</strong>` : 'datele de contact din pagina locației';
  const kind = String(s.campaignKind || '');
  const tombola = isTombola(s);
  const scratch = kind === 'scratch';
  const bon = s.receiptScan === true;
  const part = scratch || (kind === 'guaranteed' && bon)
    ? (bon ? 'poza bonului fiscal (citim din ea doar datele bonului: CUI, dată, număr)' : 'un cod anonim al telefonului (ca să primești un singur bilet)')
    : 'numele și un contact (telefon sau e-mail)';
  return [
    sjOrg
      ? `<p><strong>Cine are datele.</strong> Operatorul este <strong>${opName}</strong>${opCui}, care organizează campania; partener este <strong>${escapeHtml(s.companyName || 'localul')}</strong>, unde se desfășoară campania. Localul partener primește numele și contactul câștigătorilor, ca să le predea premiile, iar dacă bifezi separat că vrei oferte de la el, și contactul tău — pentru oferte, localul devine operator și te poți dezabona oricând de la el. Altfel, datele nu se dau mai departe și nu se vând.</p>`
      : `<p><strong>Cine are datele.</strong> Operatorul este <strong>${opName}</strong>${opCui}, care organizează campania. SpressJoy furnizează aplicația și găzduiește datele în numele localului (împuternicit); nu le folosește în alte scopuri și nu le vinde.</p>`,
    `<p><strong>Ce date și de ce.</strong></p><ul>`
      + `<li><strong>Participare:</strong> ${part}. Temei: executarea regulamentului pe care l-ai acceptat (art. 6 alin. 1 lit. b GDPR).</li>`
      + `<li><strong>Premiu:</strong> numele și telefonul sau e-mailul, codul voucherului, ca să validăm câștigătorul și să predăm premiul. Același temei.</li>`
      + (tombola ? `<li><strong>Tombolă (loterie publicitară):</strong> extragerea se face în prezența sau sub controlul unui notar, iar legea (OG 99/2000) cere publicarea numelui câștigătorilor și a premiilor. Temei: obligație legală (art. 6 alin. 1 lit. c).</li>` : '')
      + `<li><strong>Siguranță:</strong> dată, oră, IP și tipul dispozitivului, ca să prevenim fraudele. Temei: interes legitim (art. 6 alin. 1 lit. f).</li>`
      + `<li><strong>Taxe:</strong> dacă un premiu depășește pragul fiscal, datele cerute de lege pentru impozit. Temei: obligație legală.</li>`
      + `<li><strong>Oferte (opțional):</strong> doar dacă bifezi separat — vezi „detalii” la oferte. Temei: consimțământ (art. 6 alin. 1 lit. a), îl poți retrage oricând.</li></ul>`,
    `<p><strong>Cui ajung.</strong> ${sjOrg ? 'Localului partener (câștigătorii, și contactul celor care au bifat ofertele de la el)' : 'Localului și SpressJoy (găzduire, în baza unui contract de prelucrare)'}${tombola ? ', notarului care supraveghează extragerea' : ''}; autorităților, doar dacă legea o cere. Dacă un furnizor tehnic al platformei prelucrează date în afara Spațiului Economic European, transferul se face în condițiile capitolului V din GDPR, cu garanțiile prevăzute de lege.</p>`,
    `<p><strong>Cât timp.</strong> Până la 90 de zile de la finalul campaniei (validare, predarea premiilor, reclamații)${tombola ? '; lista câștigătorilor publicată, cât cere legea' : ''}; documentele fiscale, cât cere legea; contactul pentru oferte, până îți retragi acordul.</p>`,
    `<p><strong>Decizii automate.</strong> ${scratch ? 'Biletele sunt amestecate și blocate la pornirea campaniei; rezultatul nu depinde de datele tale.' : 'Nu luăm decizii automate pe baza datelor tale.'} Nu facem profilare.</p>`,
    `<p><strong>Drepturile tale.</strong> Acces, rectificare, ștergere, restricționare, portabilitate, opoziție și retragerea acordului pentru oferte. Scrie-i operatorului: ${contact}. Poți face plângere la ANSPDCP — B-dul G-ral Gheorghe Magheru 28-30, sector 1, București, anspdcp@dataprotection.ro, www.dataprotection.ro.</p>`
  ].join('');
}

function buildMKTText() {
  const currentSettings = getCurrentSettings();
  const opName = escapeHtml(currentSettings?.companyName || '[Nume firmă]');
  const opEmail = currentSettings?.operatorEmail ? escapeHtml(currentSettings.operatorEmail) : 'datele de contact din pagina locației';
  return [
    `<p>Prin selectarea opțiunii de marketing, sunteți de acord să primiți comunicări de la <strong>${opName}</strong>.</p>`,
    `<p>Puteți retrage consimțământul oricând (link de dezabonare sau mesaj la <strong>${opEmail}</strong>).</p>`,
    `<p>Date: telefonul sau e-mailul (și numele, dacă l-ai dat); fără profilare; păstrare până la retragere. Dacă nu bifezi, participi la fel.</p>`
  ].join('');
}

// Client popups
export function showGDPR() {
  // Campania cu șablon juridic aprobat: informarea COMPLETĂ, din aceeași sursă ca documentul tipărit
  const cs = getCurrentSettings() || {};
  if (getDisplayDoc('gdpr', cs)) { openLegalDoc('gdpr', cs); return; }
  const gdprContent = $('gdprContent');
  const gdprPopup = $('gdprPopup');
  if (!gdprContent || !gdprPopup) return;
  gdprContent.innerHTML = buildGDPRText();
  gdprPopup.classList.add('active');
}

export function closeGDPR() {
  const popup = $('gdprPopup');
  if (popup) popup.classList.remove('active');
}

export function showMKT() {
  const mktContent = $('mktContent');
  const mktPopup = $('mktPopup');
  const mktTitle = $('mktTitle');
  if (!mktContent || !mktPopup) return;
  const opName = String(getCurrentSettings()?.companyName || 'locație');
  if (mktTitle) {
    mktTitle.textContent = `Primește oferte de la ${opName}`;
  }
  mktContent.innerHTML = buildMKTText();
  mktPopup.classList.add('active');
}

export function closeMKT() {
  const popup = $('mktPopup');
  if (popup) popup.classList.remove('active');
}

/** Regulament auto-generat — disponibil când setările campaniei sunt încărcate. */
export function isCampaignRulesAvailable(settings = getCurrentSettings()) {
  return !!settings;
}

/** @deprecated Folosește #popupCampaignRulesBtn din HTML; păstrat pentru compatibilitate. */
export function appendCampaignRulesLink(container) {
  if (!container) return;
  const existing = document.getElementById('popupCampaignRulesBtn');
  if (existing) {
    existing.hidden = false;
    existing.style.display = 'flex';
    return;
  }
  if (!isCampaignRulesAvailable()) return;
  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'popup-rules-btn';
  btn.textContent = '📄 Vezi Regulamentul Campaniei';
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    showAutoRules();
  });
  container.appendChild(btn);
}

/* ===================== REGULAMENTE =====================
 * Campanie la noroc (câștig instant sau tombolă cu extragere) = loterie publicitară
 * (OG 99/2000, art. 41–43) → regulament autentificat la notar înainte de start.
 */
function isTombola(s) {
  if (s?.campaignKind === 'tombola') return true;
  if (s?.campaignKind === 'instant') return false;
  const prizes = (s?.prizes || []).filter((p) => (parseInt(p.count, 10) || 0) > 0);
  return prizes.length === 1 && /^bilet la extragere/i.test(String(prizes[0].message || ''));
}

/** SpressJoy SRL ca organizator (campaniile cu extragere organizate de noi, cu localul partener). */
const SPRESSJOY_ORG = {
  name: 'SPRESSJOY S.R.L.',
  cui: '54432202',
  reg: 'EUID ROONRC.J2026022907004',
  seat: 'Mioveni, Str. Profesor Ion Cojocaru nr. 32, jud. Argeș, cod 115400',
  email: 'spressjoy@gmail.com'
};
export function isSpressJoyOrganizer(s) {
  return s?.campaignOrganizer === 'spressjoy' && !['guaranteed', 'scratch'].includes(String(s?.campaignKind || ''));
}

function orgBlock(s) {
  if (isSpressJoyOrganizer(s)) {
    const slug = String(s.publicSlug || '').trim();
    const url = slug ? `${location.origin}/m/${encodeURIComponent(slug)}` : '';
    return {
      sj: true,
      name: SPRESSJOY_ORG.name,
      cui: SPRESSJOY_ORG.cui,
      partner: escapeHtml(s.companyName || 'localul partener'),
      partnerCui: escapeHtml(s.cui || ''),
      loc: escapeHtml(s.locationMapName || s.companyName || ''),
      addr: escapeHtml(s.locationMapAddress || ''),
      url: escapeHtml(url),
      email: SPRESSJOY_ORG.email
    };
  }
  const name = escapeHtml(s.companyName || '[denumirea firmei]');
  const cui = escapeHtml(s.cui || '[CUI]');
  const loc = escapeHtml(s.locationMapName || '');
  const addr = escapeHtml(s.locationMapAddress || '');
  const slug = String(s.publicSlug || '').trim();
  const url = slug ? `${location.origin}/m/${encodeURIComponent(slug)}` : '';
  return { name, cui, loc, addr, url: escapeHtml(url), email: s.operatorEmail ? escapeHtml(s.operatorEmail) : 'organizator, prin datele de contact din pagina locației' };
}

/** Regulamentul campaniei la noroc (HTML). */
function voucherDays(s) {
  return [7, 14, 30].includes(Number(s.voucherValidDays)) ? Number(s.voucherValidDays) : 7;
}
function voucherRule(s) {
  const n = voucherDays(s);
  return `Beneficiul se acordă sub forma unui voucher digital cu cod unic, salvat pe telefonul participantului. Voucherul se poate folosi <strong>începând cu ziua următoare emiterii, timp de ${n} zile</strong>, o singură dată, prin activarea lui din pagina localului (secțiunea Joy) și prezentarea ecranului de confirmare personalului. Voucherele neactivate în acest interval expiră.`;
}

function buildGuaranteedRulesHtml(s) {
  const o = orgBlock(s);
  const sDate = fmtDate(s.startDate) || '[data de început]';
  const eDate = fmtDate(s.endDate) || '[data de sfârșit]';
  const prize = (s.prizes || []).find((p) => (parseInt(p.count, 10) || 0) > 0) || {};
  const qty = parseInt(prize.count, 10) || parseInt(s.totalTries, 10) || 0;
  return `
    <p><strong>Art. 1. Organizatorul.</strong> Campania este organizată de <strong>${o.name}</strong>, CUI <strong>${o.cui}</strong>${o.loc ? `, în locația <strong>${o.loc}</strong>${o.addr ? `, ${o.addr}` : ''}` : ''}. Platforma tehnică este furnizată de SpressJoy, care nu este organizator și nu acordă beneficii.</p>
    <p><strong>Art. 2. Tipul campaniei — fără tragere la sorți.</strong> Este o campanie promoțională cu <strong>beneficiu garantat</strong>: fiecare participant care îndeplinește condițiile primește același beneficiu. Nu există extragere, câștig aleatoriu sau participanți necâștigători, deci campania nu este loterie publicitară în sensul OG nr. 99/2000.</p>
    <p><strong>Art. 3. Perioada.</strong> Între <strong>${sDate}</strong> și <strong>${eDate}</strong> inclusiv, sau până la epuizarea celor <strong>${qty > 0 ? qty : '[număr]'}</strong> beneficii, dacă survine mai devreme. Numărul de beneficii rămase este afișat în aplicație.</p>
    <p><strong>Art. 4. Beneficiul.</strong> <strong>${escapeHtml(prize.message || '[beneficiul]')}</strong>. Beneficiul se acordă ca reducere sau voucher la locație, o singură dată pe persoană, nu se schimbă pe bani și nu se cedează.</p>
    <p><strong>Art. 5. Cum participi.</strong> Participarea este gratuită${s.receiptScan ? ', pe baza bonului fiscal emis de organizator (un bon = un beneficiu; dacă bonul nu poate fi scanat, se pot introduce manual numărul și data lui, cel mult o dată pe zi de pe același telefon, iar beneficiul se acordă numai la prezentarea bonului)' : ''}. Participantul apasă butonul din pagina locației și completează numele și un contact (telefon sau e-mail). ${voucherRule(s)}</p>
    <p><strong>Art. 6. Participanți.</strong> Persoane fizice de minimum 18 ani. Organizatorul poate refuza codurile obținute prin fraudă (date false, contacte multiple pentru aceeași persoană).</p>
    <p><strong>Art. 7. Datele personale (GDPR).</strong> Operator: organizatorul; SpressJoy prelucrează datele doar ca persoană împuternicită. Se prelucrează numele, contactul și codul primit, doar pentru acordarea beneficiului (art. 6 alin. 1 lit. b GDPR). Mesajele de marketing se trimit doar cu acord separat. Datele se șterg la 90 de zile de la final. Drepturile se exercită la <strong>${o.email}</strong>; plângeri la ANSPDCP.</p>
    <p><strong>Art. 8. Modificare și încetare.</strong> Condițiile nu se schimbă pe parcurs în defavoarea participanților. Voucherele primite înainte de încheierea campaniei rămân valabile pe intervalul lor de ${voucherDays(s)} zile.</p>
    <p><strong>Art. 9. Reclamații.</strong> La <strong>${o.email}</strong>; participantul se poate adresa și ANPC.</p>
    <p><strong>Art. 10. Accesul la regulament.</strong> Regulamentul este disponibil gratuit${o.url ? ` pe pagina ${o.url}` : ''} și la cerere. Prin participare, participantul acceptă prezentul regulament.</p>`;
}

function buildScratchRulesHtml(s) {
  const o = orgBlock(s);
  const bon = s.receiptScan === true;
  const sDate = fmtDate(s.startDate) || '[data de început]';
  const eDate = fmtDate(s.endDate) || '[data de sfârșit]';
  const total = parseInt(s.scratchDeck?.size || s.totalTries || 0, 10);
  const prizes = (s.prizes || []).filter((p) => String(p.message || '').trim());
  const wins = prizes.reduce((a, p) => a + (parseInt(p.count, 10) || 0), 0);
  const totalValue = prizes.reduce((a, p) => a + (Number(p.value) > 0 ? Number(p.value) * (parseInt(p.count, 10) || 0) : 0), 0);
  const allValued = prizes.length && prizes.every((p) => Number(p.value) > 0);
  const prizesHtml = prizes.length
    ? `<ul style="margin:8px 0 8px 20px; list-style:disc;">${prizes.map((p) => {
      const v = Number(p.value) > 0 ? ` — valoare comercială ${escapeHtml(String(p.value))} lei/buc. (cu TVA)` : ' — valoare comercială: [valoare] lei/buc.';
      return `<li><strong>${parseInt(p.count, 10) || 0} buc.</strong> × ${escapeHtml(p.message)}${v}</li>`;
    }).join('')}</ul>`
    : '<p>[lista premiilor, cu numărul de bucăți și valoarea comercială]</p>';
  const lockedAt = s.scratchDeck?.createdAt ? new Date(s.scratchDeck.createdAt) : null;
  const lockedTxt = lockedAt && !Number.isNaN(lockedAt.getTime())
    ? new Intl.DateTimeFormat('ro-RO', { dateStyle: 'long', timeStyle: 'short', timeZone: 'Europe/Bucharest' }).format(lockedAt)
    : '';
  const hash = s.scratchDeck?.hash
    ? `<p>Lista a fost blocată${lockedTxt ? ` pe <strong>${escapeHtml(lockedTxt)}</strong>` : ''}. Amprenta ei digitală (SHA-256): <code style="word-break:break-all">${escapeHtml(s.scratchDeck.hash)}</code>.</p>`
    : '<p>Data și ora blocării listei și amprenta ei digitală (SHA-256) se afișează în acest regulament în momentul pornirii campaniei.</p>';
  const issuer = o.sj ? `localul partener <strong>${o.partner}</strong>${o.partnerCui ? ` (CUI ${o.partnerCui})` : ''}` : 'organizator';
  const place = o.loc ? `<strong>${o.loc}</strong>${o.addr ? `, ${o.addr}` : ''}` : 'locația organizatorului';
  const chance = total > 0 && wins > 0 ? ` La pornire, <strong>${wins}</strong> din <strong>${total}</strong> bilete sunt câștigătoare (aproximativ 1 din ${Math.max(1, Math.round(total / wins))}); pe parcurs, proporția biletelor rămase poate varia.` : '';
  let n = 0;
  const art = (title) => `<strong>Art. ${++n}. ${title}.</strong>`;
  return `
    <p>${art('Organizatorul')} Campania „Răzuiește și câștigă” este organizată de <strong>${o.name}</strong>, CUI <strong>${o.cui}</strong>${o.sj ? `, în parteneriat cu ${issuer}, unde se desfășoară campania` : ''}. Platforma tehnică este furnizată de SpressJoy${o.sj ? '' : ', care nu este organizator și nu acordă premii'}.</p>
    ${bon
      ? `<p>${art('Natura campaniei și temeiul legal')} Este o campanie promoțională cu premii <strong>alocate aleatoriu înainte de începerea campaniei</strong> și acordate <strong>la cumpărare</strong>, practică comercială permisă care nu este asimilată loteriei publicitare, potrivit art. 47 din OG nr. 99/2000 privind comercializarea produselor și serviciilor de piață. Nu există tragere la sorți, extragere sau selecție a câștigătorilor după pornire: rezultatul fiecărui bilet este stabilit înainte de începerea campaniei, iar cumpărătorul află pe loc dacă biletul său este câștigător.</p>`
      : `<p>${art('Natura campaniei')} Premiile sunt repartizate aleatoriu pe bilete <strong>înainte de începerea campaniei</strong>, iar lista de bilete este blocată și nu mai poate fi modificată. Nu există o tragere la sorți ulterioară.</p>`}
    <p>${art('Perioada și locul')} Campania se desfășoară între <strong>${sDate}</strong> și <strong>${eDate}</strong> inclusiv, în ${place}, sau până la epuizarea celor <strong>${total > 0 ? total : '[număr]'}</strong> bilete, dacă aceasta survine mai devreme. Numărul de bilete rămase este afișat permanent în pagina campaniei. Perioada nu se prelungește decât prin act adițional publicat înainte de data de sfârșit.</p>
    <p>${art('Biletele și premiile')} Campania are <strong>${total > 0 ? total : '[număr]'}</strong> bilete, dintre care <strong>${wins}</strong> câștigătoare; celelalte afișează mesajul „Ne pare rău, nu ai câștigat”. Premiile sunt:</p>${prizesHtml}
    ${allValued ? `<p>Valoarea comercială totală a premiilor este de <strong>${escapeHtml(totalValue.toLocaleString('ro-RO'))} lei</strong> (cu TVA).${chance}</p>` : (chance ? `<p>${chance.trim()}</p>` : '')}
    <p>Premiile nu se schimbă pe bani, nu se cedează și nu se înlocuiesc cu alte produse la cererea câștigătorului. Dacă un premiu nu mai poate fi acordat din motive obiective (de exemplu, produsul nu mai există în comerț), organizatorul îl înlocuiește cu un premiu de valoare egală sau mai mare.</p>
    <p>${art('Cum sunt alocate premiile')} La pornirea campaniei, aplicația generează lista completă a celor ${total > 0 ? total : '[număr]'} bilete, cu toate premiile de la articolul anterior, o amestecă folosind un generator de numere aleatorii criptografic și o blochează. Din acel moment, nici organizatorul, nici SpressJoy nu pot modifica lista, ordinea biletelor sau premiile și nu pot alege cui îi revine un anumit bilet. Biletele se acordă strict în ordinea listei, câte unul pentru fiecare ${bon ? 'bon validat' : 'participant'}, în ordinea în care ${bon ? 'bonurile sunt validate' : 'participanții le solicită'}. Rezultatul înregistrat pe server pentru fiecare bilet este cel valabil.</p>
    ${hash}
    <p>După încheierea campaniei, organizatorul pune la dispoziția oricărui participant, la cerere, lista completă a biletelor și cheia de verificare, cu care se poate confirma că lista corespunde amprentei publicate la pornire.</p>
    <p>${art('Cum participi')} ${bon
      ? `Participantul cumpără orice produs sau serviciu de la ${place}, în perioada campaniei, și primește bonul fiscal emis de ${issuer}. Apoi scanează bonul în pagina campaniei și primește pe loc următorul bilet din listă, pe care îl răzuiește pe ecran. <strong>Un bon = un bilet</strong>; același bon nu poate fi folosit de două ori, indiferent dacă a fost scanat sau introdus manual. Se acceptă doar bonuri emise în perioada campaniei de ${issuer}. Dacă bonul nu poate fi scanat, participantul poate introduce manual numărul și data bonului, cel mult o dată pe zi de pe același telefon.`
      : 'Participantul apasă butonul din pagina campaniei și primește următorul bilet din listă, pe care îl răzuiește pe ecran. <strong>Un bilet per telefon</strong>.'} Participarea nu presupune nicio taxă sau cost suplimentar${bon ? ' față de prețul produsului cumpărat' : ''}, în afara costului obișnuit al conexiunii la internet. Prețurile produselor nu cresc pe durata campaniei.</p>
    <p>${art('Cine poate participa')} Persoane fizice cu vârsta de minimum 18 ani. Nu pot participa angajații organizatorului${o.sj ? ' și ai localului partener' : ''} și rudele lor de gradul I. Participarea implică acceptarea prezentului regulament.</p>
    <p>${art('Acordarea premiilor')} Rezultatul se afișează imediat după răzuire. Câștigătorul completează pe ecran numele și un contact (telefon sau e-mail). ${voucherRule(s)} O persoană poate revendica cel mult un premiu în această campanie, identificată după telefon sau e-mail.${bon ? ' <strong>La predarea premiului, câștigătorul prezintă bonul fiscal original pe baza căruia a primit biletul</strong>, la cererea personalului; pentru biletele obținute prin introducerea manuală a datelor bonului, prezentarea bonului este obligatorie. Fără bon, premiul nu se acordă.' : ''} Premiile nerevendicate sau nefolosite în termen, precum și cele de pe biletele nedistribuite până la final, rămân în proprietatea organizatorului.</p>
    <p>${art('Invalidarea biletelor')} Organizatorul poate invalida biletele și refuza acordarea premiilor obținute prin fraudă: bonuri false, modificate, emise în afara perioadei sau de alt comerciant${bon ? ', bonuri ale altor persoane' : ''}, folosirea mai multor telefoane sau identități pentru același ${bon ? 'bon' : 'participant'}, ori orice încercare de a influența funcționarea aplicației.</p>
    <p>${art('Taxe')} Pentru premiile cu valoare de peste 600 lei, organizatorul reține și virează impozitul de 10% din diferența de peste 600 lei, potrivit art. 110 din Codul fiscal. Alte eventuale costuri legate de folosirea premiului nu sunt suportate de organizator.</p>
    <p>${art('Răspundere')} Organizatorul nu răspunde pentru imposibilitatea de a participa din cauza problemelor tehnice ale telefonului sau ale conexiunii participantului. Dacă din cauza unei erori de afișare ecranul arată alt rezultat decât cel înregistrat pe server pentru biletul respectiv, este valabil rezultatul înregistrat pe server.</p>
    <p>${art('Modificarea și încetarea campaniei')} Regulamentul se poate modifica doar prin act adițional publicat în pagina campaniei înainte de intrarea lui în vigoare; modificările nu pot schimba lista de bilete blocată la pornire și nu pot reduce premiile. Campania încetează la data de sfârșit, la epuizarea biletelor sau, înainte de termen, doar în caz de forță majoră ori dacă o autoritate o cere, cu anunț în pagina campaniei. Premiile câștigate până la încetare se acordă în condițiile regulamentului.</p>
    <p>${art('Datele personale (GDPR)')} Operator: organizatorul${o.sj ? '' : '; SpressJoy prelucrează datele doar ca persoană împuternicită'}. Se prelucrează ${bon ? 'datele bonului fiscal (CUI, dată, număr — din poza scanată sau introduse manual) și, la introducerea manuală, un cod anonim al telefonului' : 'un cod anonim al telefonului'}, iar pentru câștigători numele, contactul și premiul, pentru desfășurarea campaniei (art. 6 alin. 1 lit. b GDPR) și pentru obligațiile legale (lit. c). Mesajele de marketing se trimit doar cu acord separat. Datele se șterg la 90 de zile de la final, cu excepția celor cerute de legea fiscală. Detalii în informarea privind datele personale, disponibilă în pagina campaniei. Drepturile se exercită la <strong>${o.email}</strong>; plângeri la ANSPDCP.</p>
    <p>${art('Reclamații și litigii')} Reclamațiile se trimit la <strong>${o.email}</strong>, în cel mult 15 zile de la încheierea campaniei, și primesc răspuns în cel mult 30 de zile. Participantul se poate adresa și ANPC. Eventualele neînțelegeri se rezolvă pe cale amiabilă, iar în caz contrar de instanțele competente potrivit legii.</p>
    <p>${art('Accesul la regulament')} Regulamentul este disponibil gratuit${o.url ? ` pe pagina ${o.url}` : ' în pagina campaniei'} și, la cerere, la ${o.email}.</p>`;
}

export function buildCampaignRulesHtml(s = getCurrentSettings() || {}) {
  if (s.campaignKind === 'guaranteed') return buildGuaranteedRulesHtml(s);
  if (s.campaignKind === 'scratch') return buildScratchRulesHtml(s);
  const o = orgBlock(s);
  const tombola = isTombola(s);
  const sDate = fmtDate(s.startDate) || '[data de început]';
  const eDate = fmtDate(s.endDate) || '[data de sfârșit]';
  const totalTries = parseInt(s.totalTries || 0, 10);
  // tombola cu premii pe locuri: premiile din „Premii și date”, nu biletul de participare
  const prizes = (s.campaignKind === 'tombola' && Array.isArray(s.drawPrizes) && s.drawPrizes.length ? s.drawPrizes.map((p) => ({ count: 1, ...p })) : (s.prizes || [])).filter((p) => (parseInt(p.count, 10) || 0) > 0);
  const prizesHtml = prizes.length
    ? `<ul style="margin:8px 0 8px 20px; list-style:disc;">${prizes.map((p) => {
      const v = Number(p.value) > 0 ? ` — valoare comercială ${escapeHtml(String(p.value))} lei/buc. (cu TVA)` : ' — valoare comercială: [valoare] lei/buc.';
      return `<li><strong>${parseInt(p.count, 10)} buc.</strong> × ${escapeHtml(p.message || 'Premiu')}${v}</li>`;
    }).join('')}</ul>`
    : '<p>[lista premiilor, cu numărul de bucăți și valoarea comercială]</p>';
  const na = s.notaryAct || {};
  const notaryLine = na.confirmed
    ? `Prezentul regulament a fost autentificat de notarul public ${escapeHtml(na.office || '')}${na.number ? `, încheierea nr. ${escapeHtml(na.number)}` : ''}${na.date ? ` din ${escapeHtml(fmtDate(na.date))}` : ''}, înainte de începerea campaniei.`
    : 'Regulamentul se autentifică de un notar public înainte de începerea campaniei. Autentificarea este obligația organizatorului.';
  const mech = tombola
    ? `Participantul apasă butonul din pagina locației și primește un <strong>bilet de participare</strong>, completând numele și un contact (telefon sau e-mail). La data de <strong>${eDate}</strong> se desemnează câștigătorii prin <strong>tragere la sorți</strong>, efectuată prin aplicația SpressJoy, dintre toate biletele valide. Extragerea se face în prezența a cel puțin doi reprezentanți ai organizatorului și poate fi transmisă live.`
    : `Participantul apasă butonul din pagina locației. Sistemul stabilește imediat și aleatoriu dacă participarea este câștigătoare, în funcție de premiile și de participările rămase. Numărul total de participări al campaniei este <strong>${totalTries > 0 ? totalTries : '[număr]'}</strong>; șansa de câștig variază pe parcursul campaniei. Rezultatul este afișat imediat și nu poate fi influențat de organizator sau de participant.`;
  return `
    <p><strong>Art. 1. Organizatorul.</strong> ${o.sj
      ? `Campania este organizată de <strong>${SPRESSJOY_ORG.name}</strong>, cu sediul în ${SPRESSJOY_ORG.seat}, ${SPRESSJOY_ORG.reg}, CUI <strong>${SPRESSJOY_ORG.cui}</strong> („Organizatorul”), în parteneriat cu <strong>${o.partner}</strong>${o.partnerCui ? `, CUI ${o.partnerCui}` : ''} („Partenerul”), în locația <strong>${o.loc}</strong>${o.addr ? `, ${o.addr}` : ''}. Organizatorul derulează campania prin aplicația SpressJoy; Partenerul pune la dispoziție locația și premiile.`
      : `Campania este organizată de <strong>${o.name}</strong>, CUI <strong>${o.cui}</strong>${o.loc ? `, în locația <strong>${o.loc}</strong>${o.addr ? `, ${o.addr}` : ''}` : ''}. Platforma tehnică este furnizată de SpressJoy, care nu este organizator și nu acordă premii.`} Campania se desfășoară potrivit OG nr. 99/2000. ${notaryLine} Orice modificare se face prin act adițional autentificat, adus la cunoștința participanților înainte de a intra în vigoare.</p>
    <p><strong>Art. 2. Perioada.</strong> Între <strong>${sDate}</strong> și <strong>${eDate}</strong> inclusiv, în programul locației${tombola ? '' : ', sau până la epuizarea participărilor'}.</p>
    <p><strong>Art. 3. Participanți.</strong> Persoane fizice cu vârsta de cel puțin <strong>18 ani</strong>. Nu pot participa angajații organizatorului${o.sj ? ' și ai partenerului' : ''} și rudele lor de gradul I. <strong>Participarea este gratuită</strong> și nu implică nicio cheltuială suplimentară, în afara costului obișnuit al internetului.</p>
    <p><strong>Art. 4. Mecanismul.</strong> ${mech} O persoană poate câștiga <strong>cel mult un premiu</strong>, identificată după telefon sau e-mail.</p>
    <p><strong>Art. 5. Premiile.</strong></p>${prizesHtml}
    <p>Premiile nu se schimbă pe bani și nu se cedează. ${tombola ? '' : 'După epuizarea premiilor, participanții primesc mesajul „necâștigător”. '}</p>
    <p><strong>Art. 6. Acordarea premiilor.</strong> ${tombola ? 'Câștigătorii sunt anunțați la contactul lăsat, în cel mult 3 zile de la extragere.' : `Câștigătorul completează pe ecran numele și un contact. ${voucherRule(s)}`}${tombola ? ' Premiul se ridică din locație în cel mult 30 de zile de la încheierea campaniei.' : ''} Organizatorul poate cere un act de identitate doar pentru verificarea vârstei și a identității, fără a-l copia. Participările frauduloase se invalidează.</p>
    <p><strong>Art. 7. Taxe.</strong> Pentru premiile cu valoare de peste 600 lei, organizatorul reține și virează impozitul de 10% din diferența de peste 600 lei (art. 110 Cod fiscal). Premiile de cel mult 600 lei nu se impozitează.</p>
    <p><strong>Art. 8. Publicarea câștigătorilor.</strong> În cel mult 30 de zile de la final, organizatorul publică pe pagina campaniei câștigătorii (prenumele și inițiala numelui sau contact mascat) și premiile acordate.</p>
    <p><strong>Art. 9. Datele personale (GDPR).</strong> ${o.sj ? `Operator: Organizatorul (${SPRESSJOY_ORG.name}). Partenerul primește numele și contactul câștigătorilor, pentru predarea premiilor, și contactul participanților care bifează separat că vor oferte de la Partener; pentru acestea Partenerul devine operator și răspunde de dezabonare.` : 'Operator: organizatorul; SpressJoy prelucrează datele doar ca persoană împuternicită.'} Se prelucrează numele, contactul, data participării și premiul, pentru desfășurarea campaniei (art. 6 alin. 1 lit. b GDPR) și obligații legale (lit. c). Mesajele de marketing se trimit doar cu acord separat. Datele se șterg la 90 de zile de la final, cu excepția celor cerute de legea fiscală. Drepturile (acces, rectificare, ștergere, opoziție) se exercită la <strong>${o.email}</strong>; plângeri la ANSPDCP.</p>
    <p><strong>Art. 10. Întreruperea.</strong> Doar în caz de forță majoră sau decizie a unei autorități, cu anunț pe pagina campaniei; premiile câștigate până atunci se acordă.</p>
    <p><strong>Art. 11. Reclamații și litigii.</strong> La <strong>${o.email}</strong>, în cel mult 15 zile de la final; răspuns în 30 de zile. Litigiile se soluționează amiabil sau de instanțele competente din România; participantul se poate adresa și ANPC.</p>
    <p><strong>Art. 12. Accesul la regulament.</strong> Regulamentul este disponibil gratuit oricărui solicitant${o.url ? `, pe pagina ${o.url}` : ''} și la cerere, la <strong>${o.email}</strong>. Prin participare, participantul acceptă prezentul regulament.</p>`;
}

// Rules popup
export function showAutoRules() {
  const currentSettings = getCurrentSettings();
  if (!currentSettings) return showSnackbar('Se încarcă datele...');
  // Regulamentul oficial complet (șablon aprobat sau versiunea blocată la notar)
  if (currentSettings.ownRules?.pages?.length || getDisplayDoc('rules', currentSettings)) { openLegalDoc('rules', currentSettings); return; }
  const rulesTitle = document.getElementById('rulesPopupTitle');
  if (rulesTitle) rulesTitle.textContent = currentSettings.campaignKind === 'guaranteed' ? 'Regulament campanie (cadou garantat)' : isTombola(currentSettings) ? 'Regulament tombolă' : 'Regulament campanie';
  const rulesContent = $('rulesContent');
  const rulesPopup = $('rulesPopup');
  if (!rulesContent || !rulesPopup) return;
  rulesContent.innerHTML = buildCampaignRulesHtml(currentSettings);
  if (Array.isArray(currentSettings.ownRulesAddenda) && currentSettings.ownRulesAddenda.length) {
    import('../legal/legal-notary.js?v=83.79').then((m) => {
      m.ensureLegalCss?.();
      const add = m.buildAddendaBlock(currentSettings);
      if (add) rulesContent.prepend(add);
      const hist = m.buildHistoryBlock(currentSettings);
      if (hist) rulesContent.appendChild(hist);
    }).catch(() => {});
  }
  rulesPopup.classList.add('active');
}

/** Regulamentul ca PDF (Tipărește → Salvează ca PDF), gata de dus la notar sau de păstrat. */
export function downloadRulesPdf(kind = 'campaign') {
  const s = getCurrentSettings() || {};
  if (kind !== 'loyalty' && getDisplayDoc('rules', s)) {
    import('../legal/legal-ui.js?v=83.79').then((m) => m.printPdf('rules', s));
    return;
  }
  let html = '';
  let title = '';
  if (kind === 'loyalty') {
    showLoyaltyRules({ silent: true });
    html = $('rulesContent')?.innerHTML || '';
    title = s.loyaltySettings?.mode === 'ranking' ? 'Regulament — Clasamentul clienților' : 'Regulament — Program de fidelizare';
  } else {
    html = buildCampaignRulesHtml(s);
    title = s.campaignKind === 'guaranteed' ? 'Regulamentul campaniei promoționale cu beneficiu garantat' : isTombola(s) ? 'Regulamentul oficial al tombolei' : 'Regulamentul oficial al campaniei promoționale';
  }
  let box = document.getElementById('sjPrintReport');
  if (!box) {
    box = document.createElement('div');
    box.id = 'sjPrintReport';
    document.body.appendChild(box);
  }
  const orgSign = kind !== 'loyalty' && isSpressJoyOrganizer(s) ? `${SPRESSJOY_ORG.name}<br/>prin administrator Iordan Andrei Cosmin` : escapeHtml(s.companyName || '');
  box.innerHTML = `<div class="rp-rules"><div class="rp-brand">${kind !== 'loyalty' && isSpressJoyOrganizer(s) ? SPRESSJOY_ORG.name : escapeHtml(s.companyName || '')}</div><h1>${escapeHtml(title)}</h1>${html}
    <div class="rp-sign"><div>Organizator,<br/>${orgSign}<br/><br/>Semnătura și ștampila</div></div></div>`;
  const oldTitle = document.title;
  document.title = `${title} - ${s.companyName || ''}`.trim();
  document.body.classList.add('sj-printing-report');
  const done = () => {
    document.body.classList.remove('sj-printing-report');
    document.title = oldTitle;
    window.removeEventListener('afterprint', done);
  };
  window.addEventListener('afterprint', done);
  showSnackbar('Alege „Salvează ca PDF” în fereastra care se deschide.');
  setTimeout(() => { try { window.print(); } catch (_) { done(); } }, 300);
}

export function showLoyaltyRules(opts = {}) {
  const currentSettings = getCurrentSettings();
  if (!currentSettings) return showSnackbar('Se încarcă datele...');
  const ls = currentSettings.loyaltySettings || {};
  const rulesTitle = document.getElementById('rulesPopupTitle');
  if (rulesTitle) rulesTitle.textContent = 'Regulament Fidelizare';

  const orgName = escapeHtml(currentSettings.companyName || 'Organizator');
  const orgCui = escapeHtml(currentSettings.cui || '-');
  const orgEmail = escapeHtml(currentSettings.operatorEmail || '-');
  const sDate = fmtDate(ls.startDate);
  const eDate = fmtDate(ls.endDate);
  const required = parseInt(ls.requiredPurchases, 10) || 7;
  const rewardText = escapeHtml(ls.rewardText || 'Recompensa configurată de organizator.');
  const periodText =
    ls.startDate || ls.endDate
      ? `Programul se desfășoară între <strong>${sDate}</strong> și <strong>${eDate}</strong> (inclusiv), în programul de funcționare al locației.`
      : 'Programul este activ pe durata în care organizatorul îl menține activ în aplicație.';

  if (ls.mode === 'ranking') {
    const medals = ['Locul 1', 'Locul 2', 'Locul 3'];
    const prizes = (Array.isArray(ls.rankPrizes) ? ls.rankPrizes : []).filter(Boolean).slice(0, 3);
    const prizesHtml = prizes.length
      ? `<ul style="margin:8px 0 8px 20px; list-style:disc;">${prizes.map((p, i) => `<li><strong>${medals[i]}:</strong> ${escapeHtml(p)}</li>`).join('')}</ul>`
      : '<p>Premiile sunt afișate în aplicație.</p>';
    const minTxt = Number(ls.minAmount) > 0 ? ` de minimum <strong>${escapeHtml(String(ls.minAmount))} lei</strong>` : '';
    const rankHtml = `
    <p><strong>1. Organizator:</strong> Concursul „Clasamentul clienților” este organizat de <strong>${orgName}</strong> (CUI: <strong>${orgCui}</strong>).</p>
    <p><strong>2. Perioada:</strong> ${periodText} Câștigătorii se stabilesc la finalul zilei de <strong>${eDate}</strong>.</p>
    <p><strong>3. Mecanism — fără tragere la sorți:</strong> Câștigătorii sunt desemnați exclusiv după numărul de vizite înregistrate. O vizită se înregistrează scanând în aplicație bonul fiscal${minTxt} emis de organizator, de azi sau de ieri. Se acordă <strong>cel mult un punct pe zi</strong> pentru fiecare participant. Fiecare bon poate fi folosit o singură dată.</p>
    <p><strong>4. Premii:</strong></p>${prizesHtml}
    <p><strong>5. Clasament și egalitate:</strong> Clasamentul se actualizează în timp real în aplicație. La punctaj egal, ocupă locul mai bun participantul care a atins primul acel număr de puncte.</p>
    <p><strong>6. Eligibilitate:</strong> Pot participa persoanele fizice de minimum <strong>18 ani</strong>. Un participant este identificat printr-un singur număr de telefon și poate câștiga un singur premiu. Nu pot participa angajații organizatorului.</p>
    <p><strong>7. Acordarea premiilor:</strong> Câștigătorii sunt contactați la numărul de telefon folosit și ridică premiul din locație în cel mult 30 de zile de la final. Organizatorul poate invalida punctele obținute prin fraudă (bonuri false, mai multe numere pentru aceeași persoană).</p>
    <p><strong>8. Publicarea câștigătorilor:</strong> După final, câștigătorii sunt afișați în aplicație doar parțial (număr de telefon mascat).</p>
    <p><strong>9. Protecția datelor (GDPR):</strong> Se prelucrează numărul de telefon, numărul de puncte și datele bonurilor (dată, sumă, număr), doar pentru desfășurarea concursului și acordarea premiilor. Detalii în secțiunea GDPR din aplicație.</p>
    <p><strong>10. Modificare / întrerupere:</strong> Regulile și premiile nu se modifică pe parcurs; concursul poate fi întrerupt doar din motive obiective, cu anunț în aplicație.</p>
    <p><strong>11. Contact:</strong> <strong>${orgEmail}</strong>.</p>
    <hr style="border:0; border-top:1px solid rgba(255,255,255,0.2); margin:10px 0;">
    <p><small>Prin participare, confirmați că ați citit și acceptați prezentul regulament.</small></p>
  `;
    const rc = $('rulesContent');
    const rp = $('rulesPopup');
    if (rulesTitle) rulesTitle.textContent = 'Regulament — Clasamentul clienților';
    if (!rc || !rp) return;
    rc.innerHTML = rankHtml;
    if (!opts.silent) rp.classList.add('active');
    return;
  }

  const minTxt = Number(ls.minAmount) > 0 ? ` de minimum <strong>${escapeHtml(String(ls.minAmount))} lei</strong>` : '';
  const html = `
    <p><strong>1. Organizator:</strong> Programul de fidelizare este organizat de <strong>${orgName}</strong> (CUI: <strong>${orgCui}</strong>). Platforma tehnică este furnizată de SpressJoy, care nu acordă recompense.</p>
    <p><strong>2. Perioada:</strong> ${periodText}</p>
    <p><strong>3. Mecanism — fără tragere la sorți:</strong> Clientul scanează în aplicație bonul fiscal${minTxt} emis de organizator, de azi sau de ieri, și primește o ștampilă. Fiecare bon se folosește o singură dată. După <strong>${required}</strong> ștampile, clientul primește recompensa. Orice client care îndeplinește condiția primește recompensa; nu există extragere.</p>
    <p><strong>4. Recompensă:</strong> ${rewardText}. Recompensa se acordă ca reducere sau voucher la locație, nu se schimbă pe bani și nu se cedează.</p>
    <p><strong>5. Validare:</strong> Recompensa se acordă la casă, pe baza ecranului din aplicație. Organizatorul poate refuza bonurile duplicate sau suspecte de fraudă.</p>
    <p><strong>6. Participanți:</strong> Persoane fizice de minimum 18 ani, identificate printr-un singur număr de telefon. Participarea este gratuită.</p>
    <p><strong>7. Protecția datelor (GDPR):</strong> Operator: organizatorul; SpressJoy prelucrează datele doar ca persoană împuternicită. Se prelucrează numărul de telefon, ștampilele și datele bonurilor (dată, sumă, număr), doar pentru programul de fidelizare. Datele se șterg la 90 de zile de la încheierea programului sau la cerere. Drepturile se exercită la <strong>${orgEmail}</strong>; plângeri la ANSPDCP.</p>
    <p><strong>8. Modificare / încheiere:</strong> Ștampilele strânse până la o modificare sau încheiere rămân valabile 30 de zile pentru recompensă. Schimbările se anunță în aplicație înainte de a se aplica.</p>
    <p><strong>9. Contact și reclamații:</strong> <strong>${orgEmail}</strong>. Te poți adresa și ANPC.</p>
    <hr style="border:0; border-top:1px solid rgba(255,255,255,0.2); margin:10px 0;">
    <p><small>Prin participare, confirmați că ați citit și acceptați prezentul regulament.</small></p>
  `;

  const rulesContent = $('rulesContent');
  const rulesPopup = $('rulesPopup');
  if (!rulesContent || !rulesPopup) return;
  rulesContent.innerHTML = html;
  if (!opts.silent) rulesPopup.classList.add('active');
}

export function closeRules() {
  const popup = $('rulesPopup');
  if (popup) popup.classList.remove('active');
}

// Operator popups (register)
function buildOpGDPR() {
  return [
    `<p><strong>Declarație:</strong> Operatorul confirmă că va respecta legislația GDPR în campaniile derulate prin SpressJoy.</p>`,
    `<p><strong>Responsabilități:</strong> informare corectă a participanților, colectare minimă de date, limitarea accesului, păstrare limitată, răspuns la solicitări GDPR.</p>`,
    `<p><strong>Asumare:</strong> Operatorul este responsabil de legalitatea campaniei și de conținutul mesajelor/beneficiilor oferite.</p>`,
    `<p><strong>Notă:</strong> SpressJoy acționează ca împuternicit (procesator) pentru servicii tehnice (hosting/stocare), pe baza unui acord DPA.</p>`
  ].join('');
}

function buildOpDPA() {
  return [
    `<p><strong>DPA (Acord de Împuternicire):</strong> stabilește relația Operator (Controller) – SpressJoy (Processor).</p>`,
    `<p><strong>Ce înseamnă:</strong> SpressJoy procesează datele doar pentru a furniza aplicația (autentificare, stocare, export), conform instrucțiunilor Operatorului.</p>`,
    `<p><strong>Măsuri:</strong> criptare în tranzit, control acces, jurnalizare, minimizare date, retenție limitată.</p>`,
    `<p><strong>Subprocesatori:</strong> servicii cloud/hosting (ex: Firebase/Google), conform politicilor și clauzelor standard aplicabile.</p>`
  ].join('');
}

function buildOpTruth() {
  return [
    `<p><strong>Declarație:</strong> confirm că datele introduse la înregistrare sunt reale și că am dreptul să reprezint firma în relația cu SpressJoy.</p>`,
    `<p>Confirm că voi folosi aplicația în scopuri legale și nu voi desfășura campanii înșelătoare sau frauduloase.</p>`,
    `<p>Înțeleg că pot fi suspendat/șters în caz de abuz, iar Operatorul răspunde pentru promisiunile făcute către clienți.</p>`
  ].join('');
}

function buildVendorMkt() {
  return [
    `<p><strong>Marketing furnizor (opțional):</strong> accept să primesc comunicări de la SpressJoy despre noutăți, actualizări și oferte.</p>`,
    `<p>Frecvență estimată: max 2/lună. Te poți dezabona oricând.</p>`
  ].join('');
}

export function showOpGDPR() {
  const content = $('opGdprContent');
  const popup = $('opGdprPopup');
  if (!content || !popup) return;
  content.innerHTML = buildOpGDPR();
  popup.classList.add('active');
}

export function closeOpGDPR() {
  const popup = $('opGdprPopup');
  if (popup) popup.classList.remove('active');
}

export function showOpDPA() {
  const content = $('opDpaContent');
  const popup = $('opDpaPopup');
  if (!content || !popup) return;
  content.innerHTML = buildOpDPA();
  popup.classList.add('active');
}

export function closeOpDPA() {
  const popup = $('opDpaPopup');
  if (popup) popup.classList.remove('active');
}

export function showOpTruth() {
  const content = $('opTruthContent');
  const popup = $('opTruthPopup');
  if (!content || !popup) return;
  content.innerHTML = buildOpTruth();
  popup.classList.add('active');
}

export function closeOpTruth() {
  const popup = $('opTruthPopup');
  if (popup) popup.classList.remove('active');
}

export function showVendorMKT() {
  const content = $('vendorMktContent');
  const popup = $('vendorMktPopup');
  if (!content || !popup) return;
  content.innerHTML = buildVendorMkt();
  popup.classList.add('active');
}

export function closeVendorMKT() {
  const popup = $('vendorMktPopup');
  if (popup) popup.classList.remove('active');
}

// Close popups by clicking backdrop or ESC - EXCEPT popup-ul de rezultat (id="popup")
// NOTĂ: Logica de închidere la click pe backdrop este acum în app-new.js
// Această funcție este păstrată pentru compatibilitate dar nu mai este folosită pentru click pe backdrop
function closeAnyPopup(el) {
  if (el && el.classList.contains('popup')) {
    if (el.id === 'popup') {
      return; // Nu face nimic pentru popup-ul de rezultat
    }
    el.classList.remove('active');
  }
}

document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  // NU închide popup-urile importante cu Escape - doar prin buton OK/X
  const noEscapeClose = ['popup', 'confirmPopup', 'deleteDialog', 'adminPassPopup', 'resetPinPopup', 'changeAdminPasswordPopup'];
  document.querySelectorAll('.popup.active').forEach(p => {
    if (!noEscapeClose.includes(p.id)) {
      p.classList.remove('active');
    }
  });
});

// Client Interface Info popup
export function openClientInterfaceInfo() {
  const popup = $('clientInterfaceInfoPopup');
  if (popup) popup.classList.add('active');
}

export function closeClientInterfaceInfo() {
  const popup = $('clientInterfaceInfoPopup');
  if (popup) popup.classList.remove('active');
}

// Make available globally for onclick handlers
window.showGDPR = showGDPR;
window.closeGDPR = closeGDPR;
window.showMKT = showMKT;
window.closeMKT = closeMKT;
window.showAutoRules = showAutoRules;
window.downloadRulesPdf = downloadRulesPdf;
window.closeRules = closeRules;
window.showOpGDPR = showOpGDPR;
window.closeOpGDPR = closeOpGDPR;
window.showOpDPA = showOpDPA;
window.closeOpDPA = closeOpDPA;
window.showOpTruth = showOpTruth;
window.closeOpTruth = closeOpTruth;
window.showVendorMKT = showVendorMKT;
window.closeVendorMKT = closeVendorMKT;
window.openClientInterfaceInfo = openClientInterfaceInfo;
window.closeClientInterfaceInfo = closeClientInterfaceInfo;

// Claims Dashboard Info popup
export function openClaimsDashboardInfo() {
  const popup = $('claimsDashboardInfoPopup');
  if (popup) popup.classList.add('active');
}

export function closeClaimsDashboardInfo() {
  const popup = $('claimsDashboardInfoPopup');
  if (popup) popup.classList.remove('active');
}

window.openClaimsDashboardInfo = openClaimsDashboardInfo;
window.closeClaimsDashboardInfo = closeClaimsDashboardInfo;

// Mod Client Info popup
export function openModClientInfo() {
  const popup = $('modClientInfoPopup');
  if (popup) popup.classList.add('active');
}

export function closeModClientInfo() {
  const popup = $('modClientInfoPopup');
  if (popup) popup.classList.remove('active');
}

window.openModClientInfo = openModClientInfo;
window.closeModClientInfo = closeModClientInfo;